"use strict";

var removeTrailingZeros = require("./remove-trailing-zeros");
var strip0xPrefix = require("./strip-0x-prefix");

function abiDecodeShortStringAsInt256(int256) {
  return Buffer.from(strip0xPrefix(removeTrailingZeros(int256)), "hex").toString("utf8");
}

module.exports = abiDecodeShortStringAsInt256;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/abi-decode-short-string-as-int256.js
// module id = 1181
// module chunks = 146